import styled from "styled-components";

export const SOnboardingTemplatesTemplateStackSeparator = styled.div`
  width: 1px;
  height: 20px;
  background: var(--disabled-interactional-04);
`;
